import React from "react";
import ImageCarousel from "../comps/ImagesLoader";
import TopNav from "../comps/Top";
import StrContent from "../comps/Str-Content";
import SecondContent from "../comps/Second-Content";
import ThirdContent from "../comps/Third-Content";
import Extra from "../comps/Extra";

const Homepage = ({ limit, setLimit }) => {
  return (
    <>
      <TopNav />
      <Extra />
      <StrContent />
      <SecondContent />
      <ThirdContent />
    </>
  );
};

export default Homepage;
